// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__1ZqGs","title":"CardContainer_title__16L-P"};